import { Route, Routes } from 'react-router-dom';


import InventoryPricingList from '../../../InventoryPricing/InventoryPricingList';
import EditInventoryPricing from '../../../InventoryPricing/EditInventoryPricing';
import styled from '@emotion/styled';

const Container = styled.div`
  margin-top: 1.5rem;
`;

const InventoryPricing = () => {
  return (
    <Container>
      <Routes>
        <Route path="/pricing" element={<InventoryPricingList category="pricing" />} />
        <Route path="/pricing/edit/:id" element={<EditInventoryPricing category="pricing" />} />
        <Route path="/pricing/edit" element={<EditInventoryPricing category="pricing" />} />
      </Routes>
    </Container>
  );
};

export default InventoryPricing;